import { createSlice } from "@reduxjs/toolkit";
import { WritableDraft } from "immer/dist/types/types-external";
import { IShopGetCertificateRequest, IShopGetCertificateResponse } from "interfaces";
import { CertificateState, TCertificateData } from "types";

import { initDetail, onFulfilledDataReducer, onPendingReducer, onRejectedReducer } from "../reducers";
import { createCertificateThunk } from "../thunks";

const initialState: CertificateState = {
  certificateData: { ...initDetail },
};

type CertificateStateDraft = WritableDraft<CertificateState>;

export const getCertificate = createCertificateThunk<
  IShopGetCertificateResponse,
  IShopGetCertificateRequest
>("getCertificate");

export const certificateSlice = createSlice({
  name: "certificate",
  initialState,
  reducers: {
    clearCertificate(state) {
      state.certificateData = { ...initDetail };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCertificate.pending, onPendingReducer("certificateData"))
      .addCase(getCertificate.rejected, onRejectedReducer("certificateData"))
      .addCase(getCertificate.fulfilled, onFulfilledDataReducer<
        CertificateStateDraft,
        IShopGetCertificateResponse,
        TCertificateData
      >("certificateData"));
  },
});

export const { clearCertificate } = certificateSlice.actions;

export default certificateSlice.reducer;
